import { DataTypeEnum } from "../../enums/DataTypeEnum";
import { ColumnType } from "../../enums/DRCXEnums";

export function parseSelectedTagEquatableKey(
    equatableKey: string
): {
    columnType: ColumnType | undefined,
    tatID: number | undefined,
    tatTypeID: number | undefined,
    dataType: DataTypeEnum | undefined;
} {
    const components: string[] = equatableKey.split(":");
    const columnType = components.length > 0 && components[0].length > 0 ? Number(components[0]) : undefined;

    return {
        columnType,
        tatID: columnType === ColumnType.Tat && components.length > 1 && components[1].length > 0 ? Number(components[1]) : undefined,
        tatTypeID: columnType === ColumnType.TatType && components.length > 1 && components[1].length > 0 ? Number(components[1]) : undefined,
        dataType: components.length > 2 && components[2].length > 0 ? Number(components[2]) : undefined
    };
}